/**
 * Created by Jie Gao on 2019-01-29.
 */
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {ReelAreaView} from "@nolimitcity/slot-game/bin/core/reel/reelarea/ReelAreaView";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Elastic, TimelineLite, TweenLite} from "gsap";
import {StarStruckGameConfig} from "../StarStruckGameConfig";
import {StarStruckGameModuleConfig} from "../StarStruckGameModuleConfig";
import {StarStruckSoundConfig} from "../StarStruckSoundConfig";

export class StarStruckReelAreaView extends ReelAreaView {

    constructor(resourcesGroup?:ResourcesGroupName) {
        super(resourcesGroup);
    }

    public liftReelUp(reelView:PIXI.Container, startPos:number):void {
        const position = StarStruckGameConfig.instance.REEL_DISPLAY_POSITIONS[1];
        const symHeight:number = StarStruckGameConfig.instance.SYMBOL_HEIGHT;
        TweenLite.to(reelView, <number>GameConfig.instance.REEL_NEAR_WIN_SPIN_SPEED * 3, {y : position[1] - symHeight - startPos * symHeight});
    }

    public onSlowMotionStop(reelView:PIXI.Container, startPos:number, upwards:boolean):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        const stepDuration:number = 2.4;
        const endDuration:number = 0.6;
        const position = StarStruckGameConfig.instance.REEL_DISPLAY_POSITIONS[1];
        const symHeight:number = StarStruckGameConfig.instance.SYMBOL_HEIGHT;
        tl.add(() => {
            //StarStruckGameModuleConfig.nearwinBackground.play(1);
            SlotGame.sound.playEffect(StarStruckSoundConfig.instance.ANTICIPATION_BONUS);
        });
        tl.add(TweenLite.to(reelView, stepDuration, {y : position[1] + ((upwards ? -0.5 : 0.5) * symHeight)}));
        tl.add(TweenLite.to(reelView, 2, {y : position[1] + ((upwards ? -0.5 : 0.5) * symHeight)}));
        tl.add([
            () => {
                SlotGame.sound.playEffect(((startPos === 1) ? StarStruckSoundConfig.instance.BONUS_WIN : StarStruckSoundConfig.instance.BONUS_FAIL));
                if(startPos !== 1) {
                    StarStruckGameModuleConfig.hotZone.hide(true);
                    StarStruckGameModuleConfig.hotZone.stopHotZoneWinStar();
                } else {
                    SlotGame.sound.playAmbience(StarStruckSoundConfig.instance.BONUS_GAME_AMBIANCE, 0);
                    StarStruckGameModuleConfig.bonusWinEffect.playAnimation();
                }
            },
            TweenLite.to(reelView, endDuration, {y : position[1], ease : Elastic.easeOut})
        ]);
        return tl;
    }
}